<template>
    <b-modal v-model="modal_result.show"
             hide-footer
             centered
             size="lg"
             :title="(editing_result ? 'Editar' : 'Crear') + ' medición higiénica al GES - ' + hygienic_measurement.name "
             no-close-on-backdrop
             no-close-on-esc
    >
        <b-form @submit.prevent="validateFormGeneral()"
                data-vv-scope="result">
            <b-row>
                <b-col cols="12">
                    <b-form-group>
                        <label class="w-100">Fecha</label>
                        <el-date-picker id="date"
                                        name="date"
                                        size="small"
                                        class="w-100"
                                        :editable="false"
                                        v-model="result.date"
                                        type="date"
                                        :clearable="false"
                                        :disabled-dates="{ to: new Date() }"
                                        placeholder="Seleccione una fecha"
                                        data-vv-as=" "
                                        v-validate="'required'"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                        <div class="text-danger small"
                             v-text="errors.first('result.date')"
                        />
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group>
                        <label for="prod_component_id">Componente</label>
                        <el-select
                            v-model="result.prod_component_id"
                            id="prod_component_id"
                            name="prod_component_id"
                            filterable
                            size="small"
                            placeholder="Seleccione una opción"
                            class="w-100"
                            no-data-text="No hay datos que coincidan"
                            no-match-text="No hay datos que coincidan"
                            v-validate="'required'"
                            data-vv-as=" "
                            :remote-method="fetchComponents"
                            remote
                            style="width: 100%;"
                            >
                            <el-option
                                v-for="component in components"
                                :key="component.id"
                                :label="component.cas_number + ' - ' + component.name"
                                :value="component.id"
                            />
                        </el-select>

                        <div class="text-danger small"
                             v-text="errors.first('result.prod_component_id')"
                        />
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group>
                        <label for="interpretation">Interpretación</label>
                        <el-select v-model="result.interpretation"
                                   id="interpretation"
                                   name="interpretation"
                                   filterable
                                   remote
                                   size="small"
                                   placeholder="Seleccione una opción"
                                   class="w-100"
                                   no-data-text="No hay datos que coincidan"
                                   no-match-text="No hay datos que coincidan"
                                   v-validate="'required'"
                        >
                            <el-option v-for="interpretation in interpretations"
                                       :key="interpretation.id"
                                       :label="interpretation.text"
                                       :value="interpretation.id"
                            />
                        </el-select>
                        <div class="text-danger small"
                             v-text="errors.first('result.interpretation')"
                        />
                    </b-form-group>
                </b-col>


                <b-col cols="12">
                    <b-form-group>
                        <label for="protection_factor">Factor de protección</label>
                        <el-input id="protection_factor"
                                  name="protection_factor"
                                  size="small"
                                  v-model="result.protection_factor"
                                  data-vv-as=" "
                                  v-validate="'required|min:3|max:255'"
                                  maxlength="255"
                                  show-word-limit
                        />
                        <div class="text-danger small"
                             v-text="errors.first('result.protection_factor')"
                        />
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group>
                        <label for="result">Resultado</label>
                        <el-input id="result"
                                  name="result"
                                  type="textarea"
                                  size="small"
                                  v-model="result.result"
                                  data-vv-as=" "
                                  v-validate="'required|min:3|max:1000'"
                                  maxlength="1000"
                                  show-word-limit
                        />
                        <div class="text-danger small"
                             v-text="errors.first('result.result')"
                        />

                    </b-form-group>
                </b-col>

            </b-row>

            <b-row>
                <b-col class="text-center">
                    <hr/>

                    <b-btn variant="primary"
                           class="mx-1"
                           size="sm"
                           @click="validateFormGeneral()"
                    >
                        Guardar
                        <i class="fa fa-save"/>
                    </b-btn>
                    <b-btn variant="secondary"
                           class="mx-1"
                           size="sm"
                           @click="closeModal()"
                    >
                        <i class="fa fa-close"/> Cancelar
                    </b-btn>
                </b-col>
            </b-row>
        </b-form>
    </b-modal>
</template>


<script>
import {mapState, mapActions, mapMutations} from 'vuex';

export default {
    name: 'modal_result',
    computed: {
        ...mapState('hygienic_measurements', [
            'hygienic_measurement',
            'editing_result',
            'modal_result',
            'result',
            'interpretations',
            'components'
        ]),
    },
    methods: {
        ...mapActions('hygienic_measurements', [
            'addResult',
            'updateResult',
            'fetchComponents'
        ]),
        ...mapMutations('hygienic_measurements', [
            'setModalShow',
            'setShowToModalResult',
            'setShowToModalResults'
        ]),
        validateFormGeneral() {
            this.$validator.validateAll('result')
                .then(async (result) => {
                    if (result) {
                        if (!this.editing_result) {
                            await this.addResult();
                        } else {
                            await this.updateResult();
                        }
                    }
                });
        },
        closeModal(){
            this.setShowToModalResult(false)
            this.setShowToModalResults(true)
        }
    }
};
</script>
<style scoped>
.el-select-dropdown {
  white-space: normal !important;
  word-wrap: break-word;
  overflow-y: auto;
  max-height: 300px;
}

.el-select-dropdown__item {
  white-space: normal !important;
  word-break: break-word;
  padding: 5px 10px;
  max-width: 950px;
}

.el-select-dropdown__wrap {
  max-width: 950px !important;
  overflow-wrap: break-word;
}
</style>

